import { Component } from '@angular/core';
import { Equipamento } from '../../../../types/Equipamento.type';
import { EquipamentosService } from './equipamentos.service';
import { ToastService } from '../../../../services/toast.service';

@Component({
  selector: 'app-equipamentos',
  templateUrl: './equipamentos.component.html',
  styleUrl: './equipamentos.component.css'
})
export class EquipamentosComponent {

  equipamentos: Equipamento[] = []
  equipamentoSelecionado: Equipamento | null = null;
  displayDetalhesDialog: boolean = false;

  loading: boolean = false;
  loadingSincronizar: boolean = false;

  constructor(private equipamentosService: EquipamentosService, private toastService: ToastService){
    this.getAll()
  }

  getAll(){
    this.loading = true;
    this.equipamentosService.getAll().subscribe({
      next: (data) => { this.equipamentos = data; this.loading = false; },
      error: (value) => { console.error(value); this.loading = false }
    })
  }

  exportar(){
    this.loadingSincronizar = true;

    this.equipamentosService
      .exportar()
      .subscribe({
        next: (value) => {
          const url = window.URL.createObjectURL(value);
          const a = document.createElement('a')
          a.href = url
          a.download = 'equipamentos.xlsx'
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        },
        error: (error) => {
          this.toastService.erro("Exportar", 'Erro ao exportar:' + (error?.error ?? error));
          this.loadingSincronizar = false;
        },
        complete: () => {
          this.loadingSincronizar = false;
        },
      });
  }

  visualizarDetalhesModelo(equipamento: Equipamento) {
    this.equipamentoSelecionado = equipamento;
    this.displayDetalhesDialog = true;
  }
}
